import React from "react";
import _ from "lodash";

const Pagination = (props) => {
  const { itemCount, pageSize, onPageChange, currentPage } = props;

  const pageCount = Math.ceil(itemCount / pageSize);
  if (pageCount <= 1) return null;

  // 🟢 Smart Page Logic
  const getPages = () => {
    const pages = [];
    const delta = 1; // Show 1 page before and after current
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    let l;

    for (let i = 1; i <= pageCount; i++) {
      if (i === 1 || i === pageCount || (i >= left && i < right)) {
        pages.push(i);
      }
    }

    const pagesWithEllipsis = [];
    for (let i of pages) {
      if (l) {
        if (i - l === 2) {
          pagesWithEllipsis.push(l + 1);
        } else if (i - l !== 1) {
          pagesWithEllipsis.push("...");
        }
      }
      pagesWithEllipsis.push(i);
      l = i;
    }
    return pagesWithEllipsis;
  };

  const pages = getPages();

  return (
    <>
      <style>{`
        .custom-pagination {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 20px 0;
          font-family: 'Inter', sans-serif;
        }

        .pagination-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 32px;
          height: 32px;
          padding: 0 8px;
          border-radius: 8px;
          background: #fff;
          border: 1px solid #e2e8f0;
          color: #64748b;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          outline: none;
        }

        .pagination-btn:hover:not(.disabled):not(.active) {
          border-color: #0bc698;
          color: #0bc698;
          background: rgba(13, 223, 171, 0.05);
        }

        .pagination-btn.active {
          background: #0bc698;
          border-color: #0bc698;
          color: #fff;
          box-shadow: 0 4px 6px -1px rgba(13, 223, 171, 0.2);
        }

        .pagination-btn.disabled {
          opacity: 0.4;
          cursor: not-allowed;
          background: #f8fafc;
        }

        .pagination-btn.nav-btn {
          padding: 0 12px;
          gap: 4px;
          border: none;
          background: transparent;
        }

        .pagination-btn.nav-btn:hover:not(.disabled) {
          background: #f1f5f9;
          color: #1e293b;
        }

        .pagination-ellipsis {
          color: #94a3b8;
          font-size: 13px;
          padding: 0 2px;
        }

        .nav-icon {
          font-size: 16px;
          line-height: 1;
        }
      `}</style>
      <div className="custom-pagination">
        {/* Previous Button */}
        <button
          className={`pagination-btn nav-btn ${currentPage === 1 ? "disabled" : ""}`}
          disabled={currentPage === 1}
          onClick={(e) => onPageChange(e, currentPage - 1)}
        >
          <span className="nav-icon">←</span>
          <span className="d-none d-sm-inline">Previous</span>
        </button>

        {/* Page Numbers */}
        {pages.map((page, index) => (
          <React.Fragment key={index}>
            {page === "..." ? (
              <span className="pagination-ellipsis">...</span>
            ) : (
              <button
                className={`pagination-btn ${page === currentPage ? "active" : ""}`}
                onClick={(e) => onPageChange(e, page)}
              >
                {page}
              </button>
            )}
          </React.Fragment>
        ))}

        {/* Next Button */}
        <button
          className={`pagination-btn nav-btn ${currentPage === pageCount ? "disabled" : ""}`}
          disabled={currentPage === pageCount}
          onClick={(e) => onPageChange(e, currentPage + 1)}
        >
          <span className="d-none d-sm-inline">Next</span>
          <span className="nav-icon">→</span>
        </button>
      </div>
    </>
  );
};

export default Pagination;
